<template>
    <div class="w-view-shell">
        <div class="crumbs-shell">
            当前位置：行业资讯  >  <router-link to="/journalism"> 资讯列表 </router-link>  > 资讯详情
        </div>
        <div class="information-content">
            <div class="information-detail-shell">
                <div class="information-title">{{article_detail.article_title}}</div>
                <div class="news-img">
                    <img :src="article_detail.article_img" alt="">
                </div>
                <div class="information-html" v-html="article_detail.article_content"></div>
            </div>
            <div class="sift-shell">
                <div class="sift-title">精选推荐</div>
                <div class="sift-list">
                    <div class="sift-box handler" v-for="(item,index) in sift_list" :key="index" v-if="index<=2"
                         @click="look_detail(item,index)">
                        <div class="news-img">
                            <img :src="item.article_img" alt="">
                        </div>
                        <div class="news-name">{{item.article_title}}</div>
                        <div class="news-desc show-line-1">{{item.article_content.replace(/<.*?>/g,'').substring(0,50)}}...</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hot-shell">
            <div class="hot-title">热点聚焦</div>
            <div class="hot-list">
                <div class="hot-box handler" v-for="(item,index) in hot_list" :key="index" v-if="index<=2" @click="look_detail(item,index)">
                    <div class="news-img">
                        <img :src="item.article_img" alt="">
                    </div>
                    <div class="news-name">{{item.article_title}}</div>
                    <div class="news-descc show-line-1">{{item.article_content.replace(/<.*?>/g,'').substring(0,40)}}...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'detailss',
    data () {
      return {
        article_id: '',
        article_detail: '',
        hot_page: 1,
        hot_list: [],
        siftt_page: 1,
        sift_list: []
      }
    },
    mounted () {
      window.scrollTo(0, 0)
      if (this.$route.query.article_id) {
        this.article_id = this.$route.query.article_id
        this.get_detail()
      }
      this.get_sift()
      this.get_hot()
    },
    methods: {
      // 查看资讯详情
      look_detail (item, index) {
        this.$router.replace({
          path: '/detailss?article_id=' + item.article_id
        })
        this.$router.go(0)
      },
      get_detail () {
        this.API.post('Home/article_out-get_article_detail', {
          article_id: this.article_id
        }).then((res) => {
          this.article_detail = res.data.article_detail
        })
      },
      // 热点聚焦
      get_hot () {
        this.API.post('Home/article_out-get_article_list', {
          cate_id: 0,
          is_hot: 1, // 	热点聚焦 1
          is_suggest: 0, // 	精选推荐 1
          page_size: 10,
          page: this.hot_page
        }).then((res) => {
          this.hot_list = res.data.article_list
        })
      },
      // 精选推荐
      get_sift () {
        this.API.post('Home/article_out-get_article_list', {
          cate_id: 0,
          is_hot: 0, // 	热点聚焦 1
          is_suggest: 1, // 	精选推荐 1
          page_size: 10,
          page: this.siftt_page
        }).then((res) => {
          this.sift_list = res.data.article_list
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .w-view-shell {
        width: 1200px;

        .crumbs-shell {
            display: flex;
            align-items: center;
            height: 101px;
        }

        .information-content {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;

            .information-detail-shell {
                width: 758px;
                background-color: #fff;

                .information-title {
                    margin: 40px 30px;
                    font-size: 38px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                }

                .news-img {
                    padding: 0 30px;
                    margin-bottom: 38px;
                }

                .information-html {
                    padding: 0 30px;
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    line-height: 30px;
                    padding-bottom: 65px;
                }
            }

            .sift-shell {
                width: 420px;
                background-color: #fff;
                padding: 0 25px;

                .sift-title {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 101px;
                    font-size: 30px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                }

                .sift-list {
                    border-top: 1px solid #E5E5E5;
                    padding-top: 40px;

                    .sift-box {
                        margin-bottom: 46px;

                        .news-img {
                            width: 370px;

                            img {
                                width: 100%;
                            }
                        }

                        .news-name {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #000000;
                            margin: 18px 0 10px;
                        }

                        .news-desc {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #999999;
                            line-height: 36px;
                        }
                    }
                }
            }
        }

        .hot-shell {
            width: 100%;
            border-top: 1px solid #E5E5E5;
            margin-top: 28px;

            .hot-title {
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #18949C;
                margin: 33px 0 39px;
                position: relative;
                text-indent: 24px;

                &:after {
                    position: absolute;
                    content: "";
                    left: 0px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 9px;
                    height: 22px;
                    background: #18949C;
                }
            }

            .hot-list {
                display: flex;
                margin-bottom: 90px;

                .hot-box {
                    width: 320px;
                    margin-right: 100px;

                    .news-img {
                        width: 320px;
                        margin-bottom: 32px;

                        img {
                            width: 100%;
                        }
                    }

                    .news-name {
                        font-size: 18px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #000000;
                        margin-bottom: 22px;
                    }

                    .news-desc {
                        width: 320px;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
        }
    }
</style>
